// ENV variables
// export const {
//   NODE_ENV,
//   REACT_APP_VERSION,
//   REACT_APP_ENV: SIGNOL_STAGE,
//   REACT_APP_MOCKED: IS_APP_MOCKED,
//   REACT_APP_MOCKED_INCLUDE_CHARITY: USE_MOCKED_CHARITY,
//   REACT_APP_BASE_APIG_URL: API_BASE_URL,
//   REACT_APP_COGNITO_ENABLED: COGNITO_ENABLED,
//   REACT_APP_COGNITO_OAUTH_SERVER: COGNITO_SERVER,
//   REACT_APP_COGNITO_REDIRECT_URI: COGNITO_REDIRECT_URI,
//   REACT_APP_COGNITO_CLIENT_ID: COGNITO_APP_CLIENT_ID,
//   REACT_APP_COGNITO_ID_PROVIDERS: COGNITO_TRUSTED_CLIENTS,
//   REACT_APP_BASE_MEDIA_SERVER: SIGNOL_IMAGES_S3_BUCKET,
// } = process.env;

//Temporary during setup
export const {
  VITE_NODE_ENV,
  VITE_REACT_APP_VERSION,
  VITE_REACT_APP_ENV: SIGNOL_STAGE,
  VITE_REACT_APP_MOCKED: IS_APP_MOCKED,
  VITE_REACT_APP_MOCKED_INCLUDE_CHARITY: USE_MOCKED_CHARITY,
  VITE_REACT_APP_BASE_APIG_URL: API_BASE_URL,
  VITE_REACT_APP_COGNITO_ENABLED: COGNITO_ENABLED,
  VITE_REACT_APP_COGNITO_OAUTH_SERVER: COGNITO_SERVER,
  VITE_REACT_APP_COGNITO_REDIRECT_URI: COGNITO_REDIRECT_URI,
  VITE_REACT_APP_COGNITO_CLIENT_ID: COGNITO_APP_CLIENT_ID,
  VITE_REACT_APP_COGNITO_ID_PROVIDERS: COGNITO_TRUSTED_CLIENTS,
  VITE_REACT_APP_BASE_MEDIA_SERVER: SIGNOL_IMAGES_S3_BUCKET,
} = import.meta.env;

// public images / multimedia
export const signolImagesRepositoryURL = SIGNOL_IMAGES_S3_BUCKET;
export const NO_IMAGE_FOUND = `${signolImagesRepositoryURL}/no_image_found.png`;
export const CUSTOMER_LOGO_URL = (customerCode) => {
  return `${signolImagesRepositoryURL}/customers/${customerCode.toUpperCase()}/logo_${customerCode.toUpperCase()}_customer.png`;
};
// The three public logos each customer has under customers/{CODE}/ in the
// signol-email-images bucket (used by SendGrid email templates).
export const CUSTOMER_LOGO_URLS = (customerCode) => {
  const code = customerCode.toUpperCase();
  const base = `${signolImagesRepositoryURL}/customers/${code}`;
  return {
    square: `${base}/square_logo.png`,
    standard: `${base}/logo_${code}_customer.png`,
    footer: `${base}/logo_${code}_footer.png`,
  };
};

export const EMAIL_SIGNOL_SUPPORT = "support@signol.io";

// External Links
export const UPLOADS_TOOL_URL = "https://uploads-internal.signol.app/";
export const URL_SIGNOL_LEGAL_POLICIES = "https://www.signol.io/app-legal/";
export const URL_SIGNOL_PRIVACY_POLICY =
  "https://www.signol.io/privacy-policy/";

// AWS management (Account: #233184571179)
export const AWS_CLOUDWATCH_LOGS =
  "https://eu-west-2.console.aws.amazon.com/cloudwatch/home?region=eu-west-2#logsV2:log-groups";
export const AWS_EC2_SKYWISE =
  "https://eu-west-2.console.aws.amazon.com/lambda/home?region=eu-west-2#/functions/skywise-client-ec2-provisioner?tab=testing";

// SSO variables
export const IDP_LOGIN_URL = (customerIdP) =>
  `${COGNITO_SERVER}/oauth2/authorize?identity_provider=${customerIdP}&redirect_uri=${COGNITO_REDIRECT_URI}?saml=true&response_type=code&client_id=${COGNITO_APP_CLIENT_ID}&scope=openid+email+profile`;
export const IDP_LOGOUT_URL =
  COGNITO_ENABLED === "true" &&
  `${COGNITO_SERVER}/logout?client_id=${COGNITO_APP_CLIENT_ID}&logout_uri=${COGNITO_REDIRECT_URI}`;

// input patterns validations / error messages
export const REQUIRED_FIELD_MESSAGE = "This is a required field.";
export const MIN_LENGTH_POLICY_MESSAGE = (minLength) =>
  `Must be at least ${minLength} characters long.`;
export const MAX_LENGTH_POLICY_MESSAGE = (maxLength) =>
  `Must be up to ${maxLength} characters long.`;
export const PASSWORD_POLICY_SYMBOLS = () =>
  "@ $ ! # % * ? ~ + = & _ - . [ ] { } ( )".split(" ");
export const PASSWORD_POLICY_MESSAGE =
  "Password must contain at least one uppercase, lowercase, digit, and special character.";
export const PASSWORD_POLICY = new RegExp(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!#%*?~+=&_\-\.\[\]\{\}\(\)])[A-Za-z\d@$!#%*?~+=&_\-\.\[\]\{\}\(\)]{8,}$/,
);
export const USERNAME_POLICY = (isEmail) =>
  isEmail
    ? // email pattern
      new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i)
    : // username pattern
      new RegExp(/^[a-zA-Z0-9.@_+]+$/);
export const UUID_POLICY = new RegExp(
  /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
);

// cookies / local storage keys
export const ACCESS_TOKEN_COOKIE = "sg__accessToken";
export const REFRESH_TOKEN_COOKIE = "sg__refreshToken";
export const USER_COOKIE = "sg__currentUser"; // main user session object
export const ROLE_COOKIE = "sg__defaultProfile"; // active user role
export const SAML_SSO_COOKIE = "sg__ssoSAML";
export const LOGIN_DATE_COOKIE = "sg__lastLoginDate";
export const SESSION_ID_COOKIE = "sg__sessionId"; // used for hotjar recordings
export const IMPERSONATED_SESSION_COOKIE = "sg__impersonatedSessionContext"; // admin flag
export const VERSION_COOKIE = "sg__localAppVersion";
export const DYNAMICCONTENT_COOKIE = "sg__dynamicContentEnabled";
export const ONBOARDINGMODE_COOKIE = "sg__onboardingModeEnabled";
export const ACTIVITY_QUEUE = "sg__activityQueue";
export const LOGIN_URL = "sg__loginUrl";
export const LOGGING_OUT = "sg__loggingOut";
export const SSO_LOGIN_ATTEMPT_COOKIE = "sg__sso_email_attempt";
export const LOGIN_PENDING_REDIRECT_COOKIE = "sg__loginPendingRedirect";
export const SELECTED_BEHAVIOUR = "sg__selectedBehaviour";

// Date utils
export const STALE_TIME_1HS = 1000 * 60 * 60 * 1;
export const DAY_TIME =
  (new Date() - new Date().setDate(new Date().getDate() - 1)) / 1000;
export const TWO_DAYS_TIME =
  (new Date() - new Date().setDate(new Date().getDate() - 2)) / 1000;
export const WEEK_TIME =
  (new Date() - new Date().setDate(new Date().getDate() - 8)) / 1000;
export const MONTH_TIME =
  (new Date() - new Date().setMonth(new Date().getMonth() - 1)) / 1000;
export const QUARTER_TIME =
  (new Date() - new Date().setMonth(new Date().getMonth() - 3)) / 1000;
export const YEAR_TIME =
  (new Date() - new Date().setFullYear(new Date().getFullYear() - 1)) / 1000;

// Application user types
export const UserTypes = {
  CAPTAIN: "operator",
  FUEL_MANAGER: "manager",
  ADMINISTRATOR: "admin",
};

export const JOBPOSITIONS = [
  {
    text: "Fuel Manager",
    value: "FUEL_MANAGER",
  },
  {
    // OPERATOR (captain, pilots, chief engineers, etc.)
    text: "Captain",
    value: "CAPTAIN",
  },
];

export const UsernameTypes = {
  GUEST: "Guest",
  EMAIL_ADDRESS: "Email Address",
  USERNAME: "Username",
};

export const OperatorCodeAliasSettings = {
  aviation: {
    label: "Employee Number",
    example: "974854",
    tooltip:
      "This is a unique, private number found on your payslip or contract. If you don't know it, please ask your manager.",
    key: "operator_code",
  },
  shipping: {
    pageTitle: "Register for an online account",
    label: "Username",
    example: "XYZ-12345",
    tooltip:
      "This is a unique code (either your discharge book number or employee ID) supplied by your company.",
    key: "operator_code",
  },
};

export const DEFAULT_LANGUAGE = "en";
export const DEFAULT_INDUSTRY = "aviation";

// Root/initial loading screen copy (operational transparency, ClickUp 8693kt65x).
// Shown before auth resolves, i.e. before industry/customer is known — DynamicContent
// isn't mounted yet at this point, and the copy is the same for every industry/role anyway.
export const ROOT_LOADING_MESSAGES = [
  "Syncing your performance data...",
  "Capturing your fuel efficiency efforts...",
  "Calculating your environmental impact...",
  "Fetching your latest goal achievements...",
];
export const ROOT_LOADING_MESSAGE_INTERVAL_MS = 5000;
// Skip the loading screen entirely for near-instant loads.
export const ROOT_LOADING_SHOW_DELAY_MS = 1000;
// If auth takes this long, throw to the page-wide error boundary rather than keep cycling.
export const ROOT_LOADING_TIMEOUT_MS = 30000;

// will be dynamically updated by AuthStore depending on the customer bvr settings
export let allBehaviourLookup = {};
export let behaviourNameLookup = {};
export const getBehaviourNameLookup = (attr, value) => {
  const result = Object.values(behaviourNameLookup).find(
    (behaviour) => behaviour[attr] === value,
  );
  if (result) {
    return {
      ...result,
      key: result.behaviourKey,
      acronym: result.behaviourAcronym,
      name: result.behaviourName,
    };
  }
  return null; // Return null if no match is found
};

export const ONBOARDING_COMMITMENT_OPTIONS = {
  PERSONAL_BESTS: {
    label: "onboarding__commitment_options__personal_bests",
    image: "onboarding__step5__image2",
    overviewImage: "captain__overview__commitment_personal_bests",
    overviewText: "setting new personal bests",
  },
  ENVIRONMENT: {
    label: "onboarding__commitment_options__environment",
    image: "onboarding__step5__image1",
    overviewImage: "captain__overview__commitment_environment",
    overviewText: "helping the environment",
  },
  DECISION_PATTERNS: {
    label: "onboarding__commitment_options__decision_patterns",
    image: "onboarding__step5__image3",
    overviewImage: "captain__overview__commitment_decision_patterns",
    overviewText: "learning about your decision patterns",
  },
};

// Notification Settings
export const NotificationCategoryAliases = {
  REPORTS: ["REPORT"],
  NOTIFICATIONS: ["MILESTONE", "OTHER", "OPERATION"],
  ALL: ["REPORT", "MILESTONE", "OTHER", "OPERATION"],
};
export const NotificationCategoryIcons = {
  REPORT: "file alternate outline",
  MILESTONE: "flag outline",
  OPERATION: "archive",
  OTHER: "comment outline",
};
